/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { FileManagementListFileResponse } from "./FileManagementListFileResponse";

export type FileManagementListFileResponseApiRespoonse = {
  data?: FileManagementListFileResponse;
  status?: FileManagementListFileResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace FileManagementListFileResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
